import { render, staticRenderFns } from "./Mppay.vue?vue&type=template&id=66b81886&"
import script from "./Mppay.vue?vue&type=script&lang=js&"
export * from "./Mppay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports